var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFishHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.768,
    height: 30.563,
    viewBox: "0 0 32.768 30.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4642",
    "data-name": "Rectangle 4642",
    width: 23.515,
    height: 30.562,
    fill: "#fff",
    stroke: "#113351",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9222",
    "data-name": "Group 9222",
    transform: "translate(-38.462 -624.965)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 9.222,
    cy: 9.222,
    r: 9.222,
    transform: "translate(38.527 627.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9502",
    "data-name": "Group 9502",
    transform: "translate(47.715 624.966)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9383",
    "data-name": "Path 9383",
    d: "M32.488,21.232a.27.27,0,0,1-.292-.2,9.981,9.981,0,0,1-.8-3.016,15.143,15.143,0,0,1,.958-7.165A11.935,11.935,0,0,1,37.045,5a11.374,11.374,0,0,1,4.406-1.712c.377-.062.757-.1,1.136-.15.081-.011.11.025.122.114a9.04,9.04,0,0,0,2.458,5.181c.066.07.134.139.2.208a.212.212,0,0,1,.016.03c-.166.1-.33.2-.5.3a21.778,21.778,0,0,1-2.915,1.31c-1.028.4-2.064.767-3.088,1.174a8.546,8.546,0,0,0-2.67,1.64,6.974,6.974,0,0,0-2.2,4.066,7.045,7.045,0,0,0,.2,3A6.865,6.865,0,0,0,35.6,22.949a3.175,3.175,0,0,0,2.7,1.172,3.412,3.412,0,0,0,2.438-1.2,3.686,3.686,0,0,0,.594-.91c.019-.042.035-.085.066-.159a2.478,2.478,0,0,1-.71.467c.115-.185.231-.363.338-.548a1.449,1.449,0,0,0-.063-1.642c-.172-.253-.372-.482-.554-.715a2.075,2.075,0,0,1,.772.4,2.945,2.945,0,0,1,1.173,1.909,3.769,3.769,0,0,1-1.772,3.867c-.073.042-.147.082-.232.129a4.048,4.048,0,0,1,1.267,3.114,3.649,3.649,0,0,1-.474,1.729,4.608,4.608,0,0,0-.386-1.445,3.582,3.582,0,0,0-2.192-1.989,21.4,21.4,0,0,1-2.842-1.191,12.754,12.754,0,0,1-2.859-1.95,10.326,10.326,0,0,1-2.988-5.194,15.574,15.574,0,0,1-.415-4.8,17.807,17.807,0,0,1,.318-2.388c.009-.043.019-.086.03-.128a.05.05,0,0,1,.014-.021l.088.095a.458.458,0,0,0,.04-.132,5.289,5.289,0,0,1,.279-1.64,16.5,16.5,0,0,1,1.481-3.555,11.608,11.608,0,0,1,4.326-4.262A14.834,14.834,0,0,1,38.878.678c.13-.042.259-.084.39-.121.057-.016.2-.069.344-.1A11.678,11.678,0,0,1,42.8,0c-.044.3-.1.572-.121.847-.029.449-.035.9-.044,1.352,0,.08-.01.122-.092.13a11.966,11.966,0,0,0-5.134,1.711,12.362,12.362,0,0,0-4.63,4.965,14.586,14.586,0,0,0-1.426,4.356,15.809,15.809,0,0,0-.212,3.477A10.89,10.89,0,0,0,32.2,21.183a3.184,3.184,0,0,0,.212.38.125.125,0,0,1,.019.075c-.013.13.041.18.159.166l-.137-.328.043-.04.03.086.024-.009-.071-.283h0m3.423,3.749.171-.06c-.021-.061.047-.2-.115-.193l.079.079-.135.173",
    transform: "translate(-26.496 0)",
    fill: "#fff",
    stroke: "#113351",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9384",
    "data-name": "Path 9384",
    d: "M169.634.365c.273.016.551.017.826.051.457.056.912.133,1.368.2a1.37,1.37,0,0,1,.385.1.316.316,0,0,0,.217.072c.017,0,.255.043.28.049a.958.958,0,0,1,.147.056c.067.027.464.164.479.168l.382.083c.023.005.33.114.359.126.6.253,1.195.5,1.79.763.229.1.245.154.173.414a11.141,11.141,0,0,1-1.936,3.882c-.353.454-.745.87-1.127,1.3-.052.058-.313.309-.337.332-.2.186-.4.366-.6.546a8.644,8.644,0,0,1-2.41-8.141m1.291,2.458a.633.633,0,1,0,1.258.012.674.674,0,0,0-.625-.706.666.666,0,0,0-.633.694m1.353-1.334.005.021a.112.112,0,0,0,.02-.021s-.006-.011-.01-.017l-.015.017",
    transform: "translate(-152.565 -0.325)",
    fill: "#fff",
    stroke: "#113351",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9385",
    "data-name": "Path 9385",
    d: "M0,18.355a10.851,10.851,0,0,1,3.094-3.2,10.323,10.323,0,0,1,5.72-1.745,12.406,12.406,0,0,0-5.482,7.271A3.516,3.516,0,0,0,0,18.355",
    transform: "translate(0 -11.924)",
    fill: "#fff",
    stroke: "#113351",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9386",
    "data-name": "Path 9386",
    d: "M123.013,101.645a7.665,7.665,0,0,1-.7,2.765c-.02.041-.22.346-.346.61a2.752,2.752,0,0,1-.882.921,2.973,2.973,0,0,1-1.283.578l.488-1.219c.024.029.053-.107.068-.174a2.452,2.452,0,0,0,.035-.423c0-.035-.01-.07-.009-.1a4.433,4.433,0,0,0-.3-1.8c0-.007,0-.017-.011-.063l2.936-1.089",
    transform: "translate(-107.885 -90.38)",
    fill: "#fff",
    stroke: "#113351",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9220",
    "data-name": "Group 9220",
    transform: "translate(38.462 627.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_26",
    "data-name": "Path 26",
    transform: "translate(2.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9369",
    "data-name": "Path 9369",
    d: "M244.845,125.35l-.453-.1-3.026-.689-.3-.068.168-.248,1.447-2.137.191-.282.177.29.363.594a5.581,5.581,0,0,0,2.772-4.351,5.422,5.422,0,0,0-2.786-5.435,6.241,6.241,0,0,0-3.206-.951,6.885,6.885,0,0,0-4.061,1.495l-.159.117-.134-.143-.817-.874-.138-.148.147-.14a7.251,7.251,0,0,1,5.049-1.921,8.115,8.115,0,0,1,5.847,2.435,7.327,7.327,0,0,1,1.928,6.081,7.5,7.5,0,0,1-3.607,5.339l.387.738Z",
    transform: "translate(-234.539 -110.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9370",
    "data-name": "Path 9370",
    d: "M244.453,125.1l-.479-.913a7.216,7.216,0,0,0,1.813-11.278c-2.825-2.947-7.812-3.213-10.646-.511l.821.879c2.412-1.769,4.953-2.111,7.556-.559a5.649,5.649,0,0,1,2.905,5.667,5.867,5.867,0,0,1-3.079,4.656l-.48-.786-1.455,2.151,3.044.693m.812.616-4.559-1.038,2.178-3.219.6.989a5.371,5.371,0,0,0,2.5-4.1,5.236,5.236,0,0,0-2.7-5.275,6.054,6.054,0,0,0-3.11-.925,6.706,6.706,0,0,0-3.952,1.462l-.32.235-1.368-1.464.295-.281a7.511,7.511,0,0,1,5.232-1.995,8.382,8.382,0,0,1,6.042,2.519,7.586,7.586,0,0,1,2,6.293,7.727,7.727,0,0,1-3.562,5.418Z",
    transform: "translate(-234.539 -110.107)",
    fill: "#113252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_27",
    "data-name": "Path 27",
    transform: "translate(6.443 2.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9371",
    "data-name": "Path 9371",
    d: "M242.956,121.978a1.039,1.039,0,0,1-.86-.448,1.077,1.077,0,0,1,.122-1.48.913.913,0,0,0,.186-.531c.016-1.135.014-2.248.012-3.426q0-.582,0-1.17v-.233l.232-.017.585-.042.232-.017.033.231c.006.042.013.081.019.117a1.4,1.4,0,0,1,.029.244q0,1.162,0,2.322,0,1,0,2c0,.525.1.618.635.62.377,0,.787,0,1.291,0h1.994v1.461h-.25c-.27,0-.538,0-.8,0s-.524,0-.784,0c-.466,0-.845.006-1.191.018a2.784,2.784,0,0,0-.888.227A1.574,1.574,0,0,1,242.956,121.978Z",
    transform: "translate(-241.606 -114.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9372",
    "data-name": "Path 9372",
    d: "M242.956,121.728a1.346,1.346,0,0,0,.5-.111,2.955,2.955,0,0,1,.973-.245c.921-.033,1.842-.011,2.789-.011V120.4c-1.031,0-2.034,0-3.036,0-.679,0-.883-.207-.884-.87,0-1.44,0-2.88,0-4.319a2.709,2.709,0,0,0-.046-.327l-.585.042c0,1.562.011,3.081-.011,4.6a1.157,1.157,0,0,1-.247.691.839.839,0,0,0-.111,1.165.8.8,0,0,0,.661.349m0,.5h0a1.294,1.294,0,0,1-1.06-.547,1.319,1.319,0,0,1,.133-1.8.669.669,0,0,0,.124-.37c.016-1.133.014-2.245.012-3.422q0-.582,0-1.171v-.465l1.514-.11.066.461c.006.039.012.075.018.108a1.623,1.623,0,0,1,.033.286q0,1.164,0,2.324,0,1,0,2a.815.815,0,0,0,.04.327.852.852,0,0,0,.346.044c.377,0,.787,0,1.29,0h2.244v1.961h-.5c-.271,0-.539,0-.807,0s-.523,0-.783,0c-.463,0-.839.006-1.182.018a2.557,2.557,0,0,0-.8.209,1.816,1.816,0,0,1-.687.148Z",
    transform: "translate(-241.606 -114.348)",
    fill: "#113252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_28",
    "data-name": "Path 28",
    transform: "translate(0.033 2.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9373",
    "data-name": "Path 9373",
    d: "M232.637,119.819l-.209-.058-1.452-.4-.28-.078.119-.265,1.414-3.155.125-.278.248.176,1.215.863.166.118-.081.186-1.177,2.7Z",
    transform: "translate(-230.349 -115.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9374",
    "data-name": "Path 9374",
    d: "M232.495,119.52l1.177-2.7-1.215-.863-1.414,3.155,1.452.4m.284.6-2.43-.676,1.9-4.241,2.043,1.45Z",
    transform: "translate(-230.349 -115.201)",
    fill: "#113252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_29",
    "data-name": "Path 29",
    transform: "translate(0 6.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9375",
    "data-name": "Path 9375",
    d: "M230.95,126.135l-.045-.342-.342-2.613-.037-.282h2l.025.221.225,1.958.02.177-.161.077-1.372.655Z",
    transform: "translate(-230.241 -122.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9376",
    "data-name": "Path 9376",
    d: "M231.153,125.762l1.372-.655-.225-1.958h-1.489l.342,2.613m-.406.748-.505-3.86h2.5l.317,2.755Z",
    transform: "translate(-230.241 -122.649)",
    fill: "#113252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_30",
    "data-name": "Path 30",
    transform: "translate(0.679 9.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9377",
    "data-name": "Path 9377",
    d: "M233.22,130.848l-.156-.245-1.292-2.024-.13-.2.2-.137,1.237-.858.218-.151.138.226,1.166,1.91.11.18-.159.139-1.111.972Z",
    transform: "translate(-231.301 -126.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9378",
    "data-name": "Path 9378",
    d: "M233.219,127.587l-1.237.858,1.292,2.024,1.111-.972-1.166-1.91m.151-.713,1.662,2.722-1.866,1.632-1.864-2.92Z",
    transform: "translate(-231.301 -126.874)",
    fill: "#113252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_31",
    "data-name": "Path 31",
    transform: "translate(2.903 11.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9379",
    "data-name": "Path 9379",
    d: "M238.245,134.818,238,134.68l-2.076-1.148-.244-.135.16-.228.859-1.222.13-.185.2.111,1.76.992.19.107-.08.2-.544,1.378Z",
    transform: "translate(-235.312 -131.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9380",
    "data-name": "Path 9380",
    d: "M238.117,134.461l.544-1.378-1.76-.992-.859,1.222,2.076,1.148m.256.713-3.061-1.694,1.44-2.048,2.534,1.428Z",
    transform: "translate(-235.312 -131.433)",
    fill: "#113252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_32",
    "data-name": "Path 32",
    transform: "translate(6.298 12.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9381",
    "data-name": "Path 9381",
    d: "M244.095,135.943l-.323-.016-2.188-.106-.279-.013.044-.276.224-1.407.029-.185.185-.024a6.237,6.237,0,0,1,.789-.066c.98,0,1.2.541,1.452,1.776Z",
    transform: "translate(-241.014 -133.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9382",
    "data-name": "Path 9382",
    d: "M243.784,135.678c-.324-1.556-.524-1.7-1.964-1.513l-.224,1.407,2.188.106m.621.531-3.391-.164.37-2.327.371-.048a6.459,6.459,0,0,1,.821-.068c1.2,0,1.449.782,1.7,1.975Z",
    transform: "translate(-241.014 -133.601)",
    fill: "#113252"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishHistoryIcon);
export default __webpack_public_path__ + "static/media/FishHistoryIcon.22972e708fa13e57e3e10bca781103a9.svg";
export { ForwardRef as ReactComponent };